import { render, staticRenderFns } from "./DevutilReviews.vue?vue&type=template&id=2519b0e1&lang=pug&"
import script from "./DevutilReviews.vue?vue&type=script&lang=js&"
export * from "./DevutilReviews.vue?vue&type=script&lang=js&"
import style0 from "./DevutilReviews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports